"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageExtension = void 0;
const extensions_1 = require("remirror/extensions");
class ImageExtension extends extensions_1.ImageExtension {
    createPasteRules() {
        // override super behaviour of handling file uploads.
        return [];
    }
    createNodeSpec(extra, override) {
        const spec = super.createNodeSpec(extra, override);
        return {
            ...spec,
            selectable: true,
        };
    }
}
exports.ImageExtension = ImageExtension;
